import EmptyStateOverlay from 'components/base/empty-states/EmptyStateOverlay/EmptyStateOverlay';
import EmptyStateBackground from './images/empty-state-background.svg';
import useEmptyStateConfig from './useEmptyStateConfig';
import { FORECAST_EMPTY_STATES_TYPES } from './useEmptyStateType';

const EmptyState = ({ type = FORECAST_EMPTY_STATES_TYPES.DEFAULT }) => {
  const { Illustration, title, Description, Actions } = useEmptyStateConfig({
    type
  });

  return (
    <EmptyStateOverlay
      Background={EmptyStateBackground}
      Illustration={Illustration}
      Title={<>{title}</>}
      Description={Description}
      Actions={Actions}
    />
  );
};

export default EmptyState;
